import { keysOf } from './core.js';
// ── notes on people (Plus, decision 51): private to whoever writes them ────
/** The rating, 1 to 5. */
export const NOTE_RATING_OPTIONS = {
    1: { emoji: '😐', label: 'Neutral' },
    2: { emoji: '🙂', label: 'Okay' },
    3: { emoji: '😊', label: 'Good' },
    4: { emoji: '☺️', label: 'Great' },
    5: { emoji: '😁', label: 'Excellent' },
};
export const NOTE_VIBE_OPTIONS = {
    hot: { emoji: '🥵', label: 'Hot' },
    cool: { emoji: '😎', label: 'Cool' },
    dl: { emoji: '🥸', label: 'DL', hint: 'Down low: keeps it quiet' },
    mindblowing: { emoji: '🤯', label: 'Mindblowing' },
    rockstar: { emoji: '🤩', label: 'Rockstar' },
    pig: { emoji: '😈', label: 'Pig' },
    sweet: { emoji: '🥰', label: 'Sweet' },
    heartthrob: { emoji: '😍', label: 'Heartthrob' },
};
/** Warning badges, in the picker's order; WARNING_SEVERITY decides which goes on the avatar. */
export const NOTE_WARNING_OPTIONS = {
    catfish: { emoji: '🎣', label: 'Catfish', hint: "Doesn't look like their photos", learn: 'safety-scams' },
    dirty: { emoji: '🤢', label: 'Dirty' },
    stats_lie: { emoji: '🤥', label: 'Stats lie' },
    flake: { emoji: '😶', label: 'Flake' },
    ghost: { emoji: '👻', label: 'Ghost', hint: 'Stops answering' },
    std: { emoji: '🦠', label: 'Caught STD', learn: 'safety-sexual-health' },
    general: { emoji: '⚠️', label: 'General' },
    dangerous: { emoji: '☠️', label: 'Dangerous', learn: 'safety-meeting-up' },
    bot: { emoji: '🤖', label: 'Bot' },
    con: { emoji: '🧟', label: 'Con', learn: 'safety-scams' },
};
/** What they're into, for you to remember: never a badge, never a report (Hooker and PnP were warnings). */
export const NOTE_PLAY_OPTIONS = {
    roleplay: { emoji: '🎭', label: 'Roleplay' },
    bdsm: {
        emoji: '⛓️',
        label: 'BDSM',
        hint: 'Bondage, discipline, dominance and submission',
        learn: 'safety-consent',
    },
    dom_sub: { emoji: '👑', label: 'Dom/Sub', hint: 'One leads, one obeys' },
    pup: { emoji: '🐶', label: 'Pup', hint: 'Pup play: plays the dog, or the handler' },
    abdl: { emoji: '🍼', label: 'ABDL', hint: 'Adult baby, diaper lover' },
    dad_son: { emoji: '👨‍👦', label: 'Dad/Son', hint: 'Dad and son roleplay, between adults' },
    cnc: {
        emoji: '🥷',
        label: 'CNC',
        hint: 'Consensual non-consent: agreed ahead of time',
        learn: 'safety-consent',
    },
    cum_go: { emoji: '💦', label: 'Cum/GO', hint: 'Cum and go: gets off and leaves' },
    goon: { emoji: '🌀', label: 'Goon', hint: 'Long edging sessions, usually to porn' },
    smoke: { emoji: '💨', label: 'Smoke', hint: 'Smokes during play' },
    poppers: { emoji: '🧪', label: 'Poppers', learn: 'safety-party' },
    taboo: { emoji: '🤫', label: 'Taboo', hint: 'Taboo fantasies, between adults' },
    toxic: {
        emoji: '☣️',
        label: 'Toxic',
        hint: 'Mean, degrading talk and play, by agreement',
        learn: 'safety-consent',
    },
    pnp: { emoji: '🥳', label: 'PnP', hint: 'Party and play: uses drugs', learn: 'safety-party' },
    hooker: { emoji: '💲', label: 'Hooker', hint: 'Charges for it' },
};
export const NOTE_RATINGS = /* @__PURE__ */ [1, 2, 3, 4, 5].map((value) => ({
    value,
    ...NOTE_RATING_OPTIONS[value],
}));
export const NOTE_VIBE_KEYS = /* @__PURE__ */ keysOf(NOTE_VIBE_OPTIONS);
export const NOTE_VIBES = NOTE_VIBE_OPTIONS;
export const NOTE_WARNING_KEYS = /* @__PURE__ */ keysOf(NOTE_WARNING_OPTIONS);
export const NOTE_WARNINGS = NOTE_WARNING_OPTIONS;
export const NOTE_PLAY_KEYS = /* @__PURE__ */ keysOf(NOTE_PLAY_OPTIONS);
export const NOTE_PLAYS = NOTE_PLAY_OPTIONS;
/** Warnings that are play types now: a note sealed before the move carries them under warnings. */
export const WARNINGS_NOW_PLAY = ['hooker', 'pnp'];
/** Worst first: the one that goes on the avatar when there are several. */
const WARNING_SEVERITY = [
    'dangerous',
    'con',
    'catfish',
    'bot',
    'std',
    'dirty',
    'stats_lie',
    'flake',
    'ghost',
    'general',
];
export const worstWarning = (list) => WARNING_SEVERITY.find((w) => list.includes(w)) ?? null;
/** Warnings moderators can act on too: the note suggests a report alongside. */
export const REPORTABLE_WARNINGS = ['dangerous', 'con', 'catfish', 'bot'];
//# sourceMappingURL=notes.js.map